<template>
  <v-container grid-list-md fluid pa-0>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="700px">
        <v-card class="px-2">
          <v-card-title>
            <span class="title">{{formTitle}}</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-form v-model="valid" ref="form">
              <v-container grid-list-md fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="group.name"
                      :rules="[required]"
                      label="Name"
                      required
                      name="name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="group.description"
                      rows="2"
                      label="Description"
                      name="description"
                      hide-details
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      :items="drugs"
                      dense
                      item-text="name"
                      item-value="id"
                      label="Select Drugs"
                      multiple
                      box
                      single-line
                      hide-details
                      @change="addDrugs"
                      return-object
                    ></v-autocomplete>

                    <v-data-table :headers="headersDrugs" :items="group.drugs" hide-actions>
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.id || props.index + 1 }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>
                          <input class="pa-1" v-model="props.item.pivot.quantity">
                        </td>
                        <td>
                          <v-icon color="error" @click="removeDrug(props.item)">mdi-close</v-icon>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12 class="text-xs-right">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close">Cancel</v-btn>
                    <v-btn
                      class="mx-0"
                      :disabled="!valid"
                      :loading="saving"
                      color="primary"
                      @click="save"
                    >Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout
      row
      wrap
      align-center
      justify-end
      :class="{'rt-5': $vuetify.breakpoint.name !== 'xs'}"
    >
      <v-flex xs12 sm6 md4 mx-2 class="pointer-event-auto">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          label="Search"
          v-model="search"
          hide-details
          single-line
          outline
          class="rounded"
        >
          <v-tooltip top slot="append-outer">
            <v-icon
              class="mx-2"
              medium
              slot="activator"
              @click="dialog = true"
              color="secondary"
            >mdi-plus-circle</v-icon>

            <span>New Drug</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :search="search"
          :headers="headersGroups"
          :items="groups"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td>{{props.item.id}}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>

              <td>
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="editGroup(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template slot="expand" slot-scope="props">
            <v-data-table
              :search="search"
              :headers="headersDrugs"
              :items="props.item.drugs"
              disable-initial-sort
              hide-actions
              class="sub-table"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{props.item.id}}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.pivot.quantity }}</td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  middleware: "admin",
  data() {
    return {
      group: {
        name: "",
        description: "",
        drugs: []
      },
      required: v => !!v || "This field is required.",
      valid: true,
      search: "",
      editedIndex: -1,
      dialog: false,
      saving: false,
      headersGroups: [
        { text: "#", value: "id" },
        { text: "Group Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "", value: "name", sortable: false, width: 130 }
      ],

      headersDrugs: [
        { text: "#", value: "id" },
        { text: "Drug Name", value: "name" },
        { text: "Quantity", value: "quantity" }
      ]
    };
  },
  computed: {
    groups() {
      return this.$store.getters["base/drugGroups"];
    },
    drugs() {
      return this.$store.getters["base/drugs"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add New Drug" : "Edit Drug";
    }
  },

  methods: {
    addDrugs(drugs) {
      drugs.forEach(drug => {
        if (!this.group.drugs.find(x => x.id === drug.id)) {
          this.group.drugs.push({
            id: drug.id,
            name: drug.name,
            pivot: {
              quantity: 1
            }
          });
        }
      });
    },
    close() {
      this.saving = false;
      this.dialog = false;
      this.$refs.form.reset();
      // this.group = { name: "", description: "", drugs: [] };
      this.editedIndex = -1;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;

        let group = { };
        Object.assign(group, this.group);

        group.drugs = group.drugs.map(d => {
          return {
            id: d.id,
            name: d.name,
            quantity: d.pivot.quantity
          };
        });

        if (this.editedIndex > -1) {
          await this.axios.put(`api/drug_groups/${group.id}`, group);
        } else {
          await this.axios.post("api/drug_groups", group);
        }

        this.$store.dispatch("base/loadDrugGroups", true);
        this.close();
      }
    },

    editGroup(group) {
      this.editedIndex = group.id;
      // this.group = 
      Object.assign(this.group,group);
      this.dialog = true;
    },

    confirmDelete(group) {
      const params = {
        title: `Delete "${group.name}"`,
        message: `Are you sure, you want to delete this drug group "${
          group.name
        }"?`,
        // typeText: true,
        mode: "delete",
        onConfirm: () => this.deleteDrug(group)
      };

      this.$modal.show(params);
    },

    deleteDrug(group) {
      this.axios
        .delete(`api/drug_groups/${group.id}`)
        .then(result => {
          this.$store.dispatch("base/loadDrugGroups", true);
        })
        .catch(err => {
          this.$snackbar.error("Could not delete this group.");
        });
    }
  },
  mounted() {
    this.$store.dispatch("base/loadDrugGroups");
    this.$store.dispatch("base/loadDrugs");
  }
};
</script>

<style>
.sub-table table thead tr th,
.sub-table table tbody tr td {
  background-color: rgba(0, 0, 0, 0.05);
}

.parent-table {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.sub-table {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-top: 0;
  margin-bottom: 15px;
  margin-left: 64px;
}

.sub-table .v-table tbody td:not(.v-datatable__expand-col),
.sub-table .v-table thead th:not(.v-datatable__expand-col) {
  height: 30px;
}

.inline-input {
  padding: 0 5px;
  border: 1px solid grey;
}
</style>